export const PHONE = '+7 (499) 645-96-72'